import React, { useEffect } from "react";
// 引入 AOS 動畫庫及其樣式檔，用於在頁面中實現進場動效
import Aos from "aos";
import "aos/dist/aos.css";
// 引入本元件對應的 CSS 樣式檔
import "./signature.css";
// 引入 React Router 的 Link，用於頁面跳轉
import { Link } from "react-router-dom";

// 引入圖示
import { HiOutlineLocationMarker } from "react-icons/hi";

// 引入圖片資源
import img2 from "../../Assets/signImg/img2.jpg";

/*
  Data 陣列：
  - 儲存關於此行程頁面的主要資訊，包括圖片、標題、地點、費用、描述等。
  - 若需要新增更多行程，只需在此陣列中加入對應的物件即可。
*/
const Data = [
  {
    id: 2,
    imgSrc: img2,
    destTitle:
      "私校寄宿 · 夏令營 · 沉浸式課程體驗 · 結交全世界的朋友 · 提早適應北美留學生活 · 免費協助申請留學",
    location: "🇨🇦 · 加拿大 · 多倫多",
    company: "加拿大 · 跨文化體驗教育諮詢",
    fees: "學校費用 + 15% 服務費",
    description:
      "寄宿私立高中、大学，體驗校園生活；全英語環境，與本地學生全天候交流；私校訂製大學升學課程，專員輔導的 ESL 英文課程；高級學術研討專案（AAP），全球公民主題專案（GCP）；課後及休息日專屬活動；",
  },
];

/*
  Signature2 元件：
  - 使用 AOS 進行頁面動畫初始化。
  - 從 Data 陣列動態渲染並顯示行程資訊。
  - 提供返回主頁的按鈕。
*/
export default function Signature2() {
  // 在元件掛載時初始化 AOS，設定動畫持續時間為 2000 毫秒
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="signMain signContainer signSection">
      {/* 頁面標題區塊 */}
      <div className="signSecTitle">
        <h3 data-aos="fade-right" className="signTitle">
          沉 浸 體 驗 - 加 拿 大 全 寄 宿 私 校 / 大 學 夏 令 營
        </h3>
        <button className="signHomeBtn">
          <Link to={"/"} className="signHomeBtnLink">
            返 回 主 頁
          </Link>
        </button>
      </div>

      {/* 主要內容區：使用 Grid 佈局 */}
      <div className="signSecContent signGrid">
        {Data.map(
          ({ id, imgSrc, destTitle, location, company, fees, description }) => {
            return (
              <div key={id} data-aos="fade-up" className="signSingleDestination">
                {/* 左側文字資訊區塊 */}
                <div className="signCardInfo">
                  <h4 className="signDestTitle">{destTitle}</h4>
                  <span className="signContinent signFlex">
                    <HiOutlineLocationMarker className="icon" />
                    <span className="signName">{location}</span>
                  </span>

                  {/* 行程特色區塊 */}
                  <div className="signFees signFlex">
                    <div className="signGrade">
                      <span>
                        執行機構：{company}
                        <br />
                        <br />
                        <small>⭐️ 行 程 特 色</small>
                        <br />
                        <br />
                      </span>
                    </div>
                    <div>
                      <p>{description}</p> <br />

                      {/* 表格：各學校簡介與費用資訊 */}
                      <table width="80%">
                        <thead>
                          <tr>
                            <th width="20%">可選私校</th>
                            <th width="10%">學生年紀</th>
                            <th width="15%">學校費用</th>
                            <th width="55%">夏令營簡介</th>
                          </tr>{" "}
                          <br />
                        </thead>
                        <tbody>
                          <tr>
                            <td>Appleby College</td>
                            <td>12-16 歲</td>
                            <td>7550 加元 / 四週</td>
                            <td>
                              加拿大知名貴族私校，世界頂級私校聯盟成員，ESL 國際夏令營來自全世界不同國家的學生，個性化關注和指導，學術交流和城市觀光，體驗西式教育，建立溝通與生活技能，培養自信、獨立、冒險精神和國際社區歸屬感。為未來留學做準備
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>Pickering College</td>
                            <td>12-16 歲</td>
                            <td>6950 加元 / 四週</td>
                            <td>
                              加拿大知名寄宿制私校，依託托福考試基地，結合校園小班英文學習和暑期度假觀光，側重於英語閱讀、寫作、口語和聽力理解的訓練，最後以托福初級考試結束訓練營。更好地熟悉北美課堂模式，為留學起到良好的過渡。
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>Ridley College</td>
                            <td>12-18 歲</td>
                            <td>6995 加元 / 四週</td>
                            <td>
                              重點提供安大略省中學文憑（OSSD）所需的
                              ESL 純英文教學課，ESL 英文學分課，數學、函數、高級函數，IB 預備課。為迅速進入留學模式做好準備。
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>Upper Canada College</td>
                            <td>9-16 歲</td>
                            <td>6215 加元 / 三週</td>
                            <td>
                              200 年歷史的頂級私立貴族學校。多元化和國際化為學生提供豐富的學習機會，14-16 歲年齡組的「領導力培訓」專案尤其著名，
                              另外露營體驗，機器人、藝術電影和戲劇，各種體育運動，課後的英文課程、教員、營員相互互動迅速提升他們的英語技能。
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>
                              多倫多大學高級學術專案 Advanced Academic Program
                              （AAP）
                            </td>
                            <td>15-18 歲</td>
                            <td>5700 加元 / 三週</td>
                            <td>
                              學生有機會在暑期進入到加拿大綜合排名第一的多倫多大學學習，在大學環境中挑戰自我。本課程專案為高中生（15-18
                              歲）開設，需要學生具備較高水平的英文能力。
                              在各類專案和研討中。在這為期 3 週的專案中，學生有機會學習學科相關的一系列課程。 結課時，學生將需要提交相關學術報告並進行結課學術演講，提前適應大學教學模式，
                              有助於良好過渡到海外大學學習。
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>
                              多倫多大學世界公民專案 Global Citizenship Program
                              （GCP）
                            </td>
                            <td>15-18 歲</td>
                            <td>5700 加元 / 三週</td>
                            <td>
                              透過將來自世界各地的優秀高中學生聚集在一起，全球公民專案將為學生帶來全新的思維方式和理解方式。
                              該專案的特殊之處在於與一個團隊的學生一起，將利用這種思維和理解來創造一個潛在的解決方案，從而幫助最終的結業作業產生積極影響，範圍乃至世界。
                            </td>
                          </tr>
                          <br />
                          <tr>
                            <td>
                              英屬哥倫比亞大學（UBC）暑期未來全球領袖專案
                              （Future Global Leaders）
                            </td>
                            <td>15-18 歲</td>
                            <td>4820-5100 加元 / 兩週</td>
                            <td>
                              學生有機會在位於加拿大溫哥華，有著最美校園之稱的 TOP3 大學
                              UBC 學習，參與學術討論，適合 15-18 歲的學生。
                              在這裡，學生有機會參與由 UBC 教授和講師教授的學術課程，感受一流大學生活，並為高中畢業後的留學生活做準備。
                              在探索自己興趣的同時，結交來自世界各地的朋友。課程涵蓋科技、工程、人文、歷史、法律等領域。（課程名額有限，學生可根據自己興趣選擇）
                            </td>
                          </tr>
                          <br />
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* 參考行程區塊 */}
                  <div className="signFees">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 參 考 行 程</small>
                      </span>
                      <br />
                      <br />
                    </div>
                    <br />
                    <p>
                      實際活動內容以每個學校最終公佈為準，活動會有前後調整；或被相近內容替代；
                      <br />
                      以下試例舉一週的具體行程，更多資訊請諮詢報名：
                    </p>
                    <br />
                    <table width="70%">
                      <thead>
                        <tr>
                          <th width="20%">日期</th>
                          <th width="50%">活動</th>
                          <th width="30%">課後活動</th>
                        </tr>
                      </thead>
                      <tbody>
                        <br />
                        <tr>
                          <td>週日</td>
                          <td>抵達多倫多，接機</td>
                          <td>歡迎晚宴</td>
                        </tr>
                        <tr>
                          <td>週一</td>
                          <td>夏令營開幕式，迎新活動，校園觀光</td>
                          <td>一小時英文培訓</td>
                        </tr>
                        <tr>
                          <td>週二</td>
                          <td>全天夏令營課程活動安排</td>
                          <td>加拿大國家電視塔</td>
                        </tr>
                        <tr>
                          <td>週三</td>
                          <td>全天夏令營課程活動安排</td>
                          <td>一小時英文培訓</td>
                        </tr>
                        <tr>
                          <td>週四</td>
                          <td>全天夏令營課程活動安排</td>
                          <td>加拿大文化講座</td>
                        </tr>
                        <tr>
                          <td>週五</td>
                          <td>全天夏令營課程活動安排</td>
                          <td>一小時英文培訓</td>
                        </tr>
                        <tr>
                          <td>週六</td>
                          <td>遠足尼亞加拉瀑布</td>
                          <td>電影時光</td>
                        </tr>
                        <tr>
                          <td>週日</td>
                          <td>遊玩加拿大奇幻樂園</td>
                          <td>奧特萊斯購物</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* 參團資訊區塊 */}
                  <div className="signFees signFlex">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 參 團 信 息</small>
                      </span>
                      <br />
                      <br />
                    </div>{" "}
                    <br />
                    <table width="70%">
                      <thead>
                        <tr>
                          <th width="20%"></th>
                          <th width="0%"></th>
                          <th width="80%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>招 生</td>
                          <td></td>
                          <td>9 歲-16 歲</td>
                        </tr>
                        <br />
                        <tr>
                          <td>時 間</td>
                          <td></td>
                          <td>2024 年 7 月-8 月；共兩期</td>
                        </tr>
                        <br />
                        <tr>
                          <td>時 長</td>
                          <td></td>
                          <td>每期三週 / 四週</td>
                        </tr>
                        <br />
                        <tr>
                          <td>地 點</td>
                          <td></td>
                          <td>加拿大多倫多市</td>
                        </tr>
                        <br />
                        <tr>
                          <td>費 用</td>
                          <td></td>
                          <td>
                            <b style={{ color: "darkblue" }}>
                              學校費用包括：
                            </b>
                            課程費，學習材料，健康保險，旅遊觀光，住宿費用，每日三餐；
                            <br />
                            <b style={{ color: "darkblue" }}>
                              15% 服務費用包括：
                            </b>
                            與校方的全程溝通，報名，協助辦理赴加簽證，預定國際機票，協助接機送機，協助每週末探望學生；協助申請夏令營所在學校的留學名額；
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* 預售價格與預報名按鈕 */}
                  <div className="signPrice">
                    <h5>預 售 價 格 ：{fees}</h5>
                  </div>
                  <Link to={"/formReg"} target="_blank">
                  <button className="signBtn signFees">
                    <h4>⭐️ ⭐️ ⭐️ 預 約 報 名 - 搶 先 卡 位 ⭐️ ⭐️ ⭐️</h4>
                  </button>
                  </Link>
                </div>

                {/* 右側圖片區塊 */}
                <div className="signImageDiv">
                  <img src={imgSrc} alt={destTitle} />
                </div>
              </div>
            );
          }
        )}
      </div>
    </section>
  );
}